import { Observable, of } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { environment } from '../../../environment/environment';
import { DataSharingService } from '../../data-sharing/data-sharing.service';

export interface AddModuleVersionRequest {
  module_id: number;
  valid_from: string;
  valid_to?: string | null;
  maintenance_minutes: number;
  descriptions?: Record<string, { language_code: string; translation_text: string }>;
  subtypes?: Array<{ subtype_id: number }>;
}

export function addModuleVersion(componentDataSourceService: ComponentDataSourceService) {
  const dataSharingService = componentDataSourceService.injector.get(DataSharingService);

  return {
    name: 'AddModuleVersion',
    description: 'Adds a new version to an existing module',
    execute: (data: AddModuleVersionRequest): Observable<any> => {
      if (!data.module_id || !data.valid_from || data.maintenance_minutes === undefined) {
        return of({ success: false, error: 'Missing required fields: module_id, valid_from, maintenance_minutes' });
      }
      const payload = {
        valid_from: data.valid_from,
        valid_to: data.valid_to && data.valid_to.trim() !== '' ? data.valid_to : null,
        maintenance_minutes: data.maintenance_minutes,
        ...(data.descriptions && { descriptions: data.descriptions }),
        ...(data.subtypes && data.subtypes.length > 0 && { subtypes: data.subtypes })
      };
      return componentDataSourceService.http.post<any>(
        `${environment.apiUrl}/events/modules/${data.module_id}/versions`,
        payload,
        { headers: { 'Content-Type': 'application/json' } }
      ).pipe(
        tap(() => {
          dataSharingService.setData('modules_updated', { timestamp: Date.now(), module_id: data.module_id });
        }),
        catchError(err => {
          console.error('[AddModuleVersion] Error:', err);
          throw err;
        })
      );
    }
  };
}
